import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getReferralReward, 
    addReferralReward as postReferralReward, 
    updateReferralReward as putReferralReward, 
    deleteReferralReward as removeReferralReward,
    activateDeactivateReferralReward as activateReferralReward,
    getReferralEarn,
    getReferralStatus,
    updateReferralStatusAPI,
    updateReferralAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchReferralEarnTableColumnNames = createAsyncThunk("referralEarn/fetchTableColumnNames", async (referralEarnPayload, thunkAPI) => {
    try {
      const response = await getHeaders(referralEarnPayload); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllReferralEarn = createAsyncThunk("referralEarn/fetchAll", async (_, thunkAPI) => {
    try {
      const response = await getReferralEarn(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllReferralStatus = createAsyncThunk("referralEarn/fetchAllReferralStatus", async (_, thunkAPI) => {
    try {
      const response = await getReferralStatus(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

//Update Referral Status
export const updateReferral = createAsyncThunk("referralEarn/updateReferral", async (user, thunkAPI) => {
    try {
      const response = await updateReferralAPI(user); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// // Add Referral Earn
// export const createReferralEarn = createAsyncThunk("referralEarn/add", async (referralEarnData, thunkAPI) => {  
//     try {
//         const response = await postReferralReward(referralEarnData); // Assuming backend endpoint is the same
//         toast.success(t(response.message));
//         return response;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//     }
// });

// // Update Referral Earn
// export const updateReferralEarn = createAsyncThunk("referralEarn/update", async (referralEarnData, thunkAPI) => {
//     try {
//         const response = await putReferralReward(referralEarnData); // Assuming backend endpoint is the same
//         toast.success(t(response.message));
//         return response.data;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//     }
// });

// // Delete Referral Earn
// export const deleteReferralEarn = createAsyncThunk("referralEarn/delete", async (referralEarnIds, thunkAPI) => {
//     try {
//         const response = await removeReferralReward(referralEarnIds); // Assuming backend endpoint is the same
//         toast.success(t(response.message));
//         return response.data;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//     }
// });

// // Activate deactivate referral earn
// export const activateDeactivateReferralEarn = createAsyncThunk("referralEarn/activateDeactivate", async (referralEarnData, thunkAPI) => {
//   try {
//     const response = await activateReferralReward(referralEarnData); // Assuming backend endpoint is the same
//     toast.success(t(response.message));
//     return response.data;
//   } catch (error) {
//     return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//   }
// });

// // Upload Document for Referral Earn
// export const uploadReferralEarnDoc = createAsyncThunk(
//   "referralEarn/uploadReferralEarnDoc",
//   async (imageData, thunkAPI) => {
//   try {
//     const response = await uploadImages(imageData); // Assuming backend endpoint is the same
//     if (response.IsSuccess) {
//       toast.success(t(response.message) || "Image uploaded successfully!");
//       return response.Data; 
//     } else {
//       toast.error(t(response.message) || "Failed to upload image.");
//       return thunkAPI.rejectWithValue(response);
//     }
//   } catch (error) {
//     toast.error(error.response?.data?.message || error.message || "Something went wrong");
//     return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//   }
// });
